import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { useIntl } from "react-intl";

import { Flex } from "../../../../../_common";

function ListaAtividadesEncadeadas({ atividadesLead, classes }) {
  const intl = useIntl();
  return (
    <Flex flexDirection="column" className={classes.content}>
      <Typography variant="body1" className={classes.tituloLead}>
        {atividadesLead.nomeLead}
      </Typography>
      <Grid container alignItems="flex-start" justify="flex-start">
        <Grid item xs={6}>
          <Typography variant="body2" className={classes.tituloAtividade}>
            {intl.formatMessage({ defaultMessage: "Atividade atual" })}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.tituloAtividade} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography variant="body2">{intl.formatMessage({ defaultMessage: "Atividade encadeada" })}</Typography>
        </Grid>
        {atividadesLead.atividades?.map(atividade => (
          <>
            <Grid item xs={4}>
              <Typography variant="body1">{atividade.acaoAtual}</Typography>
            </Grid>
            <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
              <ArrowRightIcon />
            </Grid>
            <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Typography variant="body1">{atividade.proximaAcao}</Typography>
            </Grid>
          </>
        ))}
      </Grid>
    </Flex>
  );
}

ListaAtividadesEncadeadas.propTypes = {
  atividadesLead: PropTypes.object,
};
export default withStyles({
  content: {
    marginBottom: 16,
  },
  tituloLead: {
    fontWeight: 700,
    marginBottom: 8,
  },
  tituloAtividade: {
    color: " #00000099",
  },
})(ListaAtividadesEncadeadas);
